<template>
  <div class="go-in">
    <!-- 动态视差背景横幅 -->
    <div class="parallax-banner">
      <div class="overlay"></div>
      <div class="banner-content">
        <h1 class="animate__animated animate__fadeInDown">走进达通源</h1>
        <p class="animate__animated animate__fadeInUp">专业 · 创新 · 品质 · 服务</p>
      </div>
    </div>

    <div class="section" v-loading="loading">
      <!-- 公司简介部分 -->
      <div class="company-intro">
        <div class="intro-content animate-on-scroll">
          <div class="intro-text">
            <h2>公司简介</h2>
            <div class="subtitle">ABOUT US</div>
            <div class="divider"></div>
            <div class="intro-paragraphs">
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="highlight">深圳市达通源科技有限公司</span>，简称<strong>DTY</strong>，是国家认可的第三方检测机构。公司创立于<strong>2013</strong>年<strong>6</strong>月，依法注册取得工商营业执照，是一家具有独立法人的企业，主要致力于节水、节能等领域，为市场提供专业的检测、技术、咨询等服务。
              </p>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;经营范围主要包括：水量平衡测试、能源审计、能效检测、节能量审核、节能规划、能效（水效）对标、绿色工厂、绿色物业、节水型载体创建、节水节能改造及检测、节水节能宣传培训、节约型机关创建、合同能源管理、能源计量审查、碳核查、能源计量器具配备和管理、碳计量技术咨询、能源管理体系、测量管理体系、测量保证体系咨询和培训等。
              </p>
            </div>
          </div>
          <div class="intro-media">
            <div class="intro-image">
              <img src="../assets/img/companyImg.jpg" alt="公司图片" />
            </div>
            <div class="stats-container">
              <div class="stats">
                <div class="stat-item">
                  <span class="number">10+</span>
                  <span class="label">年行业经验</span>
                </div>
                <div class="stat-item">
                  <span class="number">1000+</span>
                  <span class="label">服务客户</span>
                </div>
                <div class="stat-item">
                  <span class="number">100%</span>
                  <span class="label">客户满意度</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 企业文化部分 -->
      <div class="culture-section">
        <div class="section-header">
          <h2>企业文化</h2>
          <p>CORPORATE CULTURE</p>
          <div class="divider"></div>
        </div>
        <div class="culture-grid">
          <!-- 愿景 -->
          <div class="culture-card vision-card" ref="vision">
            <div class="card-icon">
              <i class="el-icon-view"></i>
            </div>
            <div class="card-content">
              <h3>我们的愿景</h3>
              <div class="subtitle">Our Vision</div>
              <div class="text-content">
                <p>受人赞誉的行业典范</p>
                <p>持续成长的卓越企业</p>
              </div>
            </div>
          </div>

          <!-- 核心价值观 -->
          <div class="culture-card values-card" ref="values">
            <div class="card-icon">
              <i class="el-icon-star-on"></i>
            </div>
            <div class="card-content">
              <h3>核心价值观</h3>
              <div class="subtitle">Core Values</div>
              <div class="values-grid">
                <div class="value-item">
                  <div class="value-icon">诚</div>
                  <span>诚信</span>
                </div>
                <div class="value-item">
                  <div class="value-icon">责</div>
                  <span>责任</span>
                </div>
                <div class="value-item">
                  <div class="value-icon">专</div>
                  <span>专业</span>
                </div>
                <div class="value-item">
                  <div class="value-icon">团</div>
                  <span>团队</span>
                </div>
                <div class="value-item">
                  <div class="value-icon">新</div>
                  <span>创新</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 质量方针 -->
          <div class="culture-card policy-card" ref="policy">
            <div class="card-icon">
              <i class="el-icon-medal"></i>
            </div>
            <div class="card-content">
              <h3>质量方针</h3>
              <div class="subtitle">Quality Policy</div>
              <div class="policy-grid">
                <div class="policy-item">
                  <div class="policy-icon">
                    <i class="el-icon-check"></i>
                  </div>
                  <div class="policy-text">
                    <h4>公正</h4>
                    <p>坚持公平公正</p>
                  </div>
                </div>
                <div class="policy-item">
                  <div class="policy-icon">
                    <i class="el-icon-check"></i>
                  </div>
                  <div class="policy-text">
                    <h4>科学</h4>
                    <p>科学严谨态度</p>
                  </div>
                </div>
                <div class="policy-item">
                  <div class="policy-icon">
                    <i class="el-icon-check"></i>
                  </div>
                  <div class="policy-text">
                    <h4>准确</h4>
                    <p>精准检测结果</p>
                  </div>
                </div>
                <div class="policy-item">
                  <div class="policy-icon">
                    <i class="el-icon-check"></i>
                  </div>
                  <div class="policy-text">
                    <h4>改进</h4>
                    <p>持续优化提升</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 服务理念 -->
          <div class="culture-card service-card" ref="service">
            <div class="card-icon">
              <i class="el-icon-service"></i>
            </div>
            <div class="card-content">
              <h3>服务理念</h3>
              <div class="subtitle">Service Philosophy</div>
              <div class="service-philosophy">
                <div class="service-item">
                  <h4>用心服务</h4>
                  <p>专注每一个细节，超越客户期待</p>
                </div>
                <div class="service-item">
                  <h4>创造感动</h4>
                  <p>以专业赢得信赖，用服务传递价值</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 公司荣誉部分 -->
      <div class="content-honor">
        <div class="honor-big-img">
          <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
            <img v-lazy="dialogUrl" alt />
          </el-dialog>
        </div>
        <div class="top">
          <h2>公司资质</h2>
          <p>QUALIFICATIONS</p>
          <div class="border"></div>
        </div>
        <div class="honor-container">
          <div class="honor-grid">
            <div class="honor-card" v-for="(honor, index) in honorList" :key="index"
                 @click="dialogTableVisible = true; dialogUrl = honor.filePath; dialogTitle = honor.remark">
              <div class="card-image">
                <img v-lazy="honor.filePath" alt="" />
              </div>
              <div class="card-info">
                <p>{{ honor.remark }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.go-in {
  background: #fff;

  // 视差背景横幅
  .parallax-banner {
    height: 60vh;
    background: url('../assets/img/bannerImgGoin7.jpg') center/cover fixed;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;

    @media (max-width: 768px) {
      height: 40vh;
      background-attachment: scroll;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }

    .banner-content {
      position: relative;
      z-index: 1;
      padding: 0 1rem;

      h1 {
        font-size: 4rem;
        margin-bottom: 1rem;
        font-weight: 600;

        @media (max-width: 768px) {
          font-size: 2.8rem;
        }
      }

      p {
        font-size: 1.5rem;
        letter-spacing: 0.5rem;

        @media (max-width: 768px) {
          font-size: 1.2rem;
          letter-spacing: 0.3rem;
        }
      }
    }
  }

  // 公司简介部分
  .company-intro {
    padding: 6rem 0;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);

    @media (max-width: 768px) {
      padding: 3rem 0;
    }

    .intro-content {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 2rem;

      .intro-text {
        position: relative;
        padding: 3rem 2rem;
        background: white;
        border-radius: 20px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.05);
        margin-bottom: 4rem;
        text-align: center;

        h2 {
          font-size: 4rem;
          color: black;
          margin-bottom: 1.5rem;
          font-weight: 600;
        }

        .subtitle {
          color: #0d1217;
          font-size: 2rem;
          margin-bottom: 1.5rem;
          letter-spacing: 2px;
        }

        .divider {
          width: 60px;
          height: 3px;
          background: #409EFF;
          margin: 0 auto 4rem;
        }

        .intro-paragraphs {
          max-width: 1200px;
          margin: 0 auto;
          text-align: left;
          
          p {
            color: #0d1217;
            line-height: 2;
            margin-bottom: 3rem;
            font-size: 1.6rem;
            text-align: justify;

            .highlight {
              color: #409EFF;
              font-weight: 600;
              font-size: 1.8rem;
              padding: 0 5px;
            }

            strong {
              color: #2c3e50;
              font-weight: 600;
              font-size: 1.7rem;
            }
          }
        }
      }

      .intro-media {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 3rem;
        align-items: stretch;

        .intro-image {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 15px 40px rgba(0,0,0,0.05);
          background: white;
          padding: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            max-width: 100%;
            max-height: 450px;
            object-fit: contain;
          }
        }

        .stats-container {
          background: white;
          border-radius: 20px;
          padding: 2rem;
          box-shadow: 0 15px 40px rgba(0,0,0,0.05);
          display: flex;
          align-items: center;

          .stats {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            height: 100%;

            .stat-item {
              text-align: center;
              padding: 2rem;
              border-radius: 15px;
              background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
              border: 1px solid #eef2f7;
              transition: all 0.3s ease;

              &:hover {
                transform: translateY(-5px);
                border-color: #409EFF;
              }

              .number {
                display: block;
                font-size: 3.5rem;
                font-weight: 700;
                margin-bottom: 1rem;
                color: #409EFF;
              }

              .label {
                font-size: 1.5rem;
                color: #666;
                font-weight: 500;
              }
            }
          }
        }
      }
    }

    @media (max-width: 1024px) {
      .intro-text {
        padding: 3rem;

        h2 {
          font-size: 3.5rem;
        }

        .subtitle {
          font-size: 1.8rem;
        }

        .intro-paragraphs p {
          font-size: 1.4rem;

          .highlight {
            font-size: 1.6rem;
          }

          strong {
            font-size: 1.5rem;
          }
        }
      }

      .intro-media {
        grid-template-columns: 1fr;
        gap: 2rem;

        .intro-image, .stats-container {
          height: auto;
          padding: 1.5rem;
        }

        .stats-container .stats {
          flex-direction: row;
          gap: 1rem;

          .stat-item {
            padding: 1.5rem;

            .number {
              font-size: 2.5rem;
            }

            .label {
              font-size: 1.1rem;
            }
          }
        }
      }
    }

    @media (max-width: 768px) {
      padding: 4rem 0;

      .intro-content {
        padding: 0 1rem;

        .intro-text {
          padding: 2rem;

          h2 {
            font-size: 3rem;
          }

          .subtitle {
            font-size: 1.6rem;
          }

          .intro-paragraphs p {
            font-size: 1.3rem;

            .highlight {
              font-size: 1.4rem;
            }

            strong {
              font-size: 1.3rem;
            }
          }
        }

        .intro-media {
          gap: 1.5rem;

          .stats-container {
            .stats {
              flex-direction: column;
              gap: 1rem;

              .stat-item {
                padding: 1rem;

                .number {
                  font-size: 2.2rem;
                }

                .label {
                  font-size: 1rem;
                }
              }
            }
          }
        }
      }
    }
  }

  // 企业文化部分
  .culture-section {
    padding: 6rem 0;
    background: linear-gradient(180deg, #fff 0%, #f8f9fa 100%);

    .section-header {
      text-align: center;
      margin-bottom: 4rem;

      h2 {
        font-size: 2.8rem;
        color: #2c3e50;
        margin-bottom: 1rem;
        font-weight: 600;
      }

      p {
        font-size: 1.2rem;
        color: #666;
        letter-spacing: 2px;
      }

      .divider {
        width: 60px;
        height: 3px;
        background: #409EFF;
        margin: 1.5rem auto;
      }
    }

    .culture-grid {
      max-width: 1400px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 2.5rem;
      padding: 0 2rem;

      .culture-card {
        background: white;
        border-radius: 15px;
        padding: 2.5rem;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);

        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 40px rgba(64, 158, 255, 0.1);

          .card-icon {
            transform: scale(1.1);
            background: #409EFF;
            color: white;
          }
        }

        .card-icon {
          position: absolute;
          top: 2rem;
          right: 2rem;
          width: 50px;
          height: 50px;
          border-radius: 12px;
          background: rgba(64, 158, 255, 0.1);
          color: #409EFF;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.8rem;
          transition: all 0.3s ease;
        }

        .card-content {
          h3 {
            font-size: 1.8rem;
            color: #2c3e50;
            margin-bottom: 0.8rem;
            font-weight: 600;
          }

          .subtitle {
            color: #666;
            font-size: 1rem;
            margin-bottom: 2rem;
            letter-spacing: 1px;
          }
        }
      }

      .vision-card {
        .text-content {
          margin-top: 2rem;
          
          p {
            font-size: 1.4rem;
            color: #2c3e50;
            margin-bottom: 1rem;
            font-weight: 500;
            line-height: 1.6;
          }
        }
      }

      .values-card {
        .values-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 1rem;
          margin-top: 2rem;

          .value-item {
            text-align: center;

            .value-icon {
              width: 50px;
              height: 50px;
              margin: 0 auto 1rem;
              background: #409EFF;
              color: white;
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 1.3rem;
              transition: all 0.3s ease;
            }

            span {
              color: #2c3e50;
              font-size: 1rem;
              font-weight: 500;
            }

            &:hover .value-icon {
              transform: translateY(-5px);
              box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
            }
          }
        }
      }

      .policy-card {
        .policy-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 2rem;
          margin-top: 2rem;

          .policy-item {
            display: flex;
            align-items: flex-start;
            gap: 1rem;

            .policy-icon {
              width: 40px;
              height: 40px;
              background: rgba(64, 158, 255, 0.1);
              color: #409EFF;
              border-radius: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 1.2rem;
              flex-shrink: 0;
              transition: all 0.3s ease;
            }

            .policy-text {
              h4 {
                color: #2c3e50;
                font-size: 1.2rem;
                margin-bottom: 0.5rem;
                font-weight: 600;
              }

              p {
                color: #666;
                font-size: 0.9rem;
                line-height: 1.4;
              }
            }

            &:hover .policy-icon {
              background: #409EFF;
              color: white;
              transform: rotate(360deg);
            }
          }
        }
      }

      .service-card {
        .service-philosophy {
          margin-top: 2rem;

          .service-item {
            margin-bottom: 1.5rem;
            padding-left: 1rem;
            border-left: 3px solid #409EFF;

            h4 {
              color: #2c3e50;
              font-size: 1.4rem;
              margin-bottom: 0.5rem;
              font-weight: 600;
            }

            p {
              color: #666;
              font-size: 1rem;
              line-height: 1.6;
            }
          }
        }
      }
    }

    @media (max-width: 1200px) {
      .culture-grid {
        grid-template-columns: 1fr;
        gap: 2rem;

        .values-card .values-grid {
          grid-template-columns: repeat(3, 1fr);
        }
      }
    }

    @media (max-width: 768px) {
      padding: 3rem 0;

      .section-header {
        margin-bottom: 2rem;
        padding: 0 1rem;

        h2 {
          font-size: 2.5rem;
        }

        p {
          font-size: 1.2rem;
        }
      }

      .culture-grid {
        grid-template-columns: 1fr;
        gap: 2rem;
        padding: 0 1rem;

        .culture-card {
          padding: 2rem;

          .card-icon {
            width: 40px;
            height: 40px;
            font-size: 1.5rem;
          }

          .card-content {
            h3 {
              font-size: 1.8rem;
            }

            .subtitle {
              font-size: 1.2rem;
              margin-bottom: 1.5rem;
            }

            .text-content p,
            .values-grid .value-item span,
            .policy-grid .policy-item p,
            .service-philosophy .service-item p {
              font-size: 1.2rem;
            }
          }
        }
      }
    }
  }

  // 公司荣誉部分
  .content-honor {
    padding: 80px 0;
    background: #f8f9fa;

    .top {
      text-align: center;
      margin-bottom: 50px;

      h2 {
        font-size: 2.5rem;
        color: #2c3e50;
        margin-bottom: 15px;
        font-weight: 600;
      }

      p {
        font-size: 1.2rem;
        color: #666;
        margin-bottom: 15px;
      }

      .border {
        width: 60px;
        height: 3px;
        background: #409EFF;
        margin: 0 auto;
      }
    }

    .honor-container {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
    }

    .honor-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 30px;
      justify-content: center;
    }

    .honor-card {
      background: white;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
      cursor: pointer;
      transition: all 0.3s ease;
      height: 360px;
      display: flex;
      flex-direction: column;
      position: relative;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 12px 25px rgba(64, 158, 255, 0.15);

        .card-image {
          background: rgba(64, 158, 255, 0.03);

          &::after {
            opacity: 1;
          }

          img {
            transform: scale(1.05);
          }
        }

        .card-info {
          background: #f8f9fa;
          
          p {
            color: #409EFF;
          }
        }
      }

      .card-image {
        height: 280px;
        padding: 20px;
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        transition: all 0.3s ease;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(64, 158, 255, 0.1) 0%, rgba(64, 158, 255, 0.05) 100%);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        img {
          max-width: calc(100% - 20px);
          max-height: calc(100% - 20px);
          object-fit: contain;
          transition: all 0.3s ease;
          z-index: 1;
        }
      }

      .card-info {
        flex: 1;
        padding: 15px 20px;
        background: white;
        border-top: 1px solid #f0f0f0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;

        p {
          margin: 0;
          color: #2c3e50;
          font-size: 1.1rem;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 10px;
          transition: all 0.3s ease;
          font-weight: 500;
        }
      }

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background: linear-gradient(90deg, transparent, #409EFF, transparent);
        transform: scaleX(0);
        opacity: 0;
        transition: all 0.3s ease;
      }

      &:hover::before {
        transform: scaleX(1);
        opacity: 1;
      }
    }

    @media (max-width: 1200px) {
      .honor-grid {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    @media (max-width: 768px) {
      padding: 3rem 0;

      .top {
        margin-bottom: 2rem;
        padding: 0 1rem;

        h2 {
          font-size: 2.5rem;
        }

        p {
          font-size: 1.2rem;
        }
      }

      .honor-container {
        padding: 0 1rem;

        .honor-grid {
          gap: 1.5rem;

          .honor-card {
            height: auto;

            .card-image {
              height: 200px;
              padding: 1rem;
            }

            .card-info p {
              font-size: 1.1rem;
              padding: 0.8rem;
            }
          }
        }
      }

      .honor-big-img {
        :deep(.el-dialog__wrapper) {
          .el-dialog {
            width: 90% !important;
            margin: 10vh auto !important;

            .el-dialog__body {
              padding: 1rem;

              img {
                max-height: 60vh;
              }
            }
          }
        }
      }
    }
  }

  .honor-big-img {
    :deep(.el-dialog__wrapper) {
      .el-dialog {
        margin: 0 auto !important;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        max-width: 90%;
        
        .el-dialog__body {
          padding: 20px;
          text-align: center;
          
          img {
            max-width: 100%;
            max-height: 80vh;
            object-fit: contain;
          }
        }
      }
    }
  }

  .top {
    h3,
    p {
      text-align: center;
      color: black;
      font-weight: 600;
      font-family: 黑体;
      padding: 10px 0;
    }

    h3 {
      font-size: 30px;
    }

    p {
      font-size: 20px;
    }

    .border {
      border-bottom: 1px solid #060707;
      width: 15%;
      margin: 0 auto;
    }
  }
}

// 响应式设计
@media (max-width: 1024px) {
  .go-in {
    .parallax-banner {
      height: 40vh;

      .banner-content {
        h1 {
          font-size: 3rem;
        }
      }
    }

    .company-intro .intro-content {
      grid-template-columns: 1fr;
    }

    .culture-section .culture-grid {
      grid-template-columns: 1fr;
    }
  }
}

@media (max-width: 1200px) {
  .parallax-banner {
    height: 25vh!important;
  }
}

@media (max-width: 768px) {
  .parallax-banner {
    height: 25vh!important;
  }
  .go-in {
    .parallax-banner .banner-content {
      h1 {
        font-size: 2.5rem;
      }

      p {
        font-size: 1.2rem;
      }
    }

    .content-honor {
      .honor-show {
        grid-template-columns: 1fr;
        
        li {
          .honor-image {
            height: 250px;
          }
        }
      }

      :deep(.el-dialog) {
        width: 95% !important;
        margin: 0 auto;
      }
    }
  }
}

// 动画类
.animate__animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.animate__fadeInDown {
  animation-name: fadeInDown;
}

.animate__fadeInUp {
  animation-name: fadeInUp;
}

@media (max-width: 768px) {
  .animate__animated {
    animation-duration: 0.5s;
  }
}
</style>

<script>
export default {
  data() {
    return {
      loading: true,
      honorList: [],
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
      isFullscreen: false
    };
  },
  
  mounted() {
    this.fetchData();
    this.setupIntersectionObserver();
    
    // 监听全屏变化
    document.addEventListener('fullscreenchange', () => {
      this.isFullscreen = !!document.fullscreenElement;
    });
    document.addEventListener('webkitfullscreenchange', () => {
      this.isFullscreen = !!document.webkitFullscreenElement;
    });
    document.addEventListener('msfullscreenchange', () => {
      this.isFullscreen = !!document.msFullscreenElement;
    });
  },
  
  methods: {
    setupIntersectionObserver() {
      const options = {
        root: null,
        threshold: 0.1
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            observer.unobserve(entry.target);
          }
        });
      }, options);

      // 观察所有需要动画的元素
      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        observer.observe(el);
      });
    },

    fetchData() {
      this.$http.get("honor/list")
        .then(response => {
          this.honorList = response.data.data.map(honor => ({
            ...honor,
            filePath: this.imgserver + honor.filePath
          }));
          this.loading = false;
        })
        .catch(error => {
          console.error('Error fetching honors:', error);
          this.loading = false;
        });
    },

    showHonorDetail(honor) {
      this.dialogUrl = honor.filePath;
      this.dialogTitle = honor.remark;
      this.dialogTableVisible = true;
    },

    handleImageClick(e) {
      if (!this.isFullscreen) {
        const img = e.target;
        if (img.requestFullscreen) {
          img.requestFullscreen();
        } else if (img.webkitRequestFullscreen) {
          img.webkitRequestFullscreen();
        } else if (img.msRequestFullscreen) {
          img.msRequestFullscreen();
        }
        this.isFullscreen = true;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.isFullscreen = false;
      }
    }
  }
};
</script>